import { render, staticRenderFns } from "./BoardCardsLogistic.vue?vue&type=template&id=94d2e6da&"
import script from "./BoardCardsLogistic.vue?vue&type=script&lang=js&"
export * from "./BoardCardsLogistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports